module.exports = __webpack_public_path__ + "img/delivery-truck.bcf21a08.svg";